import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import CircularLoader from "../../../Components/CircularLoader/CircularLoader.js";
import "./NftCategories.css";
import searchicon from '../../../Images/Icons/searchicon.png'
import filtericon from '../../../Images/Icons/filter.png'
import {
  DropDownSection,
  FilterContainer,
  FilterWrapper,
  H1,
  H2,
  Image,
  ImageWrapper,
  Link,
  List,
  ListWrapper,
  NavSection,
  NavSectionWrapper,
  NftGridContainer,
  NftGridWrapper,
  NftNameText,
  NftNameWrapper,
  NftNewArival,
  NftNewArivalWrapper,
  PriceButtonContainer,
  SearchIcon,
  SearchInput,
  SearchWrapper,
  SubCatMobile,
  SubCatSection,
} from "./Styled";
import { useNavigate } from "react-router-dom";
import CategoriesFilter from "./CategoriesFilter";
import axios from "axios";
import { NftCountText, PriceWrapper } from "../NftmarketGridStyledComponent";
import Loading from "../../../Components/Loader";
import environmentVariables from "../../../config/environmentVariables.js";


const Root = styled.div``;
const Container = styled.div``;
const NftCategory = styled.div`
  font-size: 9px;
  font-weight: 800;
  color: #490d81;
  text-transform: uppercase;
  /* background-color: #d3b1f3; */
  background-color: ${(props) =>
    props.common ? "#dddddd" : props.uncommon ? "#22363e" : "initial"};
  padding: 7px 12px;
  border-radius: 50px;
  position: absolute;
  bottom: 10px;
  right: 8px;
  /* opacity: 0.7; */
  ${(p) =>
    p.uncommon &&
    `
   background-color: #22363e;
    color: #74bccb;
  `};
  ${(p) =>
    p.common &&
    `
    background-color: #392e4a;
    color: #a98bc5;
  `};
`;
const Button = styled.button`
  border-radius: 30px;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 20px;
  text-align: center;
  padding: 10px 18px;
  color: #000;
  border: none;
  outline: none;
  cursor: pointer;
  -webkit-transition: 0.5s;
  transition: 0.5s;
  background: white;
  outline: none;
  cursor: pointer;
  transition: 0.5s;
  &:hover {
    background: #1c3741;
    color: #208da5;
  }
  @media (max-width: 768px) {
    padding: 13px 40px;
  }
  /* @media (max-width: 1024px) {
    padding: 0;
  } */
`;
const ContentText = styled.text`
  font-size: 22px;
  font-weight: 600;
  /* margin: 4px 0; */
  font-style: normal;
  padding: 10px 0px;
  line-height: 22px;
  text-transform: capitalize;
  color: #ffffff;
`;
const PriceText = styled.text`
  ${(p) =>
    p.Heading &&
    `
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #8A8AA0;
    text-align: start;
    margin: 0;
`}
  ${(p) =>
    p.PriceTextValue &&
    `
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 20px;
    color: #25a8c5;
    margin: 5px 0 0px 0;
    text-align: start;
`}
${(p) =>
    p.PriceHashValue &&
    `
    font-size: 18px;
    font-weight: 600;
    font-style: normal;
    color: #fff;
`}
`;

const NftCategorisTabs = ({ list, allContractDetails }) => {
  const navigation = useNavigate();
  const abortControllerRef=useRef();
  const [activeLine, setActiveLine] = useState(null);
  const [selectedSubCat,setSelectedSubCat]=useState("all")
  const [showingList, setShowingList] = useState({});
  const [shootdata, setShootData] = useState(null);
  const [searchKey,setSearchKey]=useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [subCategoriesData,setSubCategoriesData]=useState(null)
  const [showSubCatFilter,setShowSubCatFilter]=useState(false);
  const [isLoadingNFTs, setIsLoadingNFTs] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [showMobileFilter, setShowMobileFilter] = useState(false);
  // const [commonTab , setCommonTab] = useState();
  const [selectFilter, setSelectFilter] = useState("all");
  const debounceTimeout=useRef();
  const { id } = useParams();

  // console.log("--------------", id);

  // console.log("showingList", showingList);
  // console.log("list", list);
  const handleChange = (e, value) => {
    setPage(value);
  };
  const ShootableHandle = () => {
  if(abortControllerRef.current){
      abortControllerRef.current.abort();
    }
    
    abortControllerRef.current=new AbortController();
    setShootData(null);
    let data = FilterDataComparison();
    axios
      .post(
        `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/getfiltereddata/${id}/${page}?address=${allContractDetails?.address}`,
        data,
        {signal:abortControllerRef.current.signal}
      )
      // .then((response) => {
      //   console.log(response.data);
      //   setShootData(response.data);
      // })
      .then((response) => {
        console.log(response.data[0].resData, "shootables data");
        // console.log("filterdata6666666666", response.data[0].tokenDetails);
        if (Array.isArray(response.data[0].resData)) {
          setShootData(response.data[0].resData);
          setTotalPages(response.data[0].totalPages);
          setIsLoadingNFTs(false);
        } else {
          console.error("API response is not an array:", response.data);
        }
        // setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        // setIsLoading(false);
        setIsLoadingNFTs(false);
      });
  };

  const fetchSubCategories=()=>{
    try{
      if(id!=null&&id!=undefined){
        axios.get(`${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get/subcategories/${id}`).then(response=>{
          if(response?.data?.success==true){
            setSubCategoriesData(response?.data?.data)
            setSelectedSubCat("all")
          }else{
            setSubCategoriesData([])
            setSelectedSubCat("all")
          }
        }).catch(err=>{
          console.log(err)
          setSubCategoriesData([])
          setSelectedSubCat("all")
        })
      }
    }catch(err){
      console.log(err)
    }
  }

  useEffect(() => {
    setTotalPages(0);
    setIsLoadingNFTs(true);
    ShootableHandle();
  }, [activeLine, selectFilter, allContractDetails, id]);
  useEffect(()=>{
    fetchSubCategories();
  },[id])
  const getFilterData = () => {
    // console.log("222222", activeLine, selectFilter);
    //   let data = {
    //     "category": activeLine,
    //     "price": selectFilter
    //   };

    //   let config = {
    //     method: 'post',
    //     url: `https://nftbe.metaspacechain.com/nftmarketplace/api/v1//getfiltereddata/${id}`,
    //     headers: {
    //       'Content-Type': 'application/json'
    //     },
    //     data : data
    //   };

    //   axios.request(config)
    //   .then((response) => {
    //     console.log("11111111111",response);
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
    if(abortControllerRef.current){
      abortControllerRef.current.abort();
    }
    
    abortControllerRef.current=new AbortController();
    let data = FilterDataComparison();

    /**
     * commented for tesing double api calling
     *
     */
    axios
      .post(
        `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/getfiltereddata/${id}/${page}?address=${allContractDetails?.address}`,
        data,
        {signal:abortControllerRef.current.signal}
      )
      .then((response) => {
        // console.log("1111111", response.data[0].tokenDetails);
        setShootData(response.data[0].resData);
        setTotalPages(response.data[0].totalPages);
        setIsLoadingNFTs(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  //////
  useEffect(() => {
    setShootData(null);
    setTotalPages(0);
    setIsLoadingNFTs(true);
    getFilterData();
  }, [activeLine, selectFilter, page, id,selectedSubCat,allContractDetails]);

  useEffect(() => {
    if(debounceTimeout.current) clearTimeout(debounceTimeout.current);
    debounceTimeout.current = setTimeout(() => {
       if(searchKey&&searchKey.length>3){
      setShootData(null);
    setTotalPages(0);
    // setIsLoadingNFTs(true);
    getFilterData();
    }else if(searchKey.length==0){
      setShootData(null);
    setTotalPages(0);
    // setIsLoadingNFTs(true);
    getFilterData();
    }
    }, 1000);
    return ()=>{
      if(debounceTimeout.current) clearTimeout(debounceTimeout.current)
    }
  }, [searchKey]);

  const FilterDataComparison = () => {
    const obj = {};
    if (selectFilter === "plth") {
      obj.price = 1;
    } else if (selectFilter === "phtl") {
      obj.price = -1;
    } else if (selectFilter === "latest") {
      obj.time = 1;
    }
    if (activeLine !== "all") {
      obj.category = activeLine;
    }
    if(selectedSubCat!="all"){
      obj.subcat=selectedSubCat
    }
    if(searchKey!=null&&searchKey!=undefined&&searchKey.trim()!=""&&searchKey.length>3){
      obj.search=searchKey
    }
    return obj;
  };

  useEffect(() => {
    setPage(1);
    setTotalPages(0);
    if (activeLine == "Common") {
      if (
        Object.entries(list)?.length > 0 &&
        Object.entries(list)[0]?.length > 0 &&
        Object.entries(list)[0]?.[1]
      ) {
        let copyData = Object.entries(list)[0][1];
        // console.log("copyData in common", copyData);
        const updatedList =
          Object.entries(list)[0][1]?.fetchDetails?.length > 0 &&
          Object.entries(list)[0][1]?.fetchDetails.filter(
            (nftDetail) => nftDetail.category == "common"
          );
        // console.log("copyData in common", updatedList);
        setShowingList([{ ...copyData, fetchDetails: updatedList }]);
      }
    }
    if (activeLine == "Uncommon") {
      if (
        Object.entries(list)?.length > 0 &&
        Object.entries(list)[0]?.length > 0 &&
        Object.entries(list)[0]?.[1]
      ) {
        const copyData = Object.entries(list)[0][1];
        // console.log("copyData in Uncommon", copyData);
        const updatedList =
          Object.entries(list)[0][1]?.fetchDetails?.length > 0 &&
          Object.entries(list)[0][1]?.fetchDetails.filter(
            (nftDetail) => nftDetail.category == "uncommon"
          );
        // console.log("copyData in Uncommon", updatedList);
        setShowingList([{ ...copyData, fetchDetails: updatedList }]);
      }
    }
    if (activeLine == "Rare") {
      if (
        Object.entries(list)?.length > 0 &&
        Object.entries(list)[0]?.length > 0 &&
        Object.entries(list)[0]?.[1]
      ) {
        const copyData = Object.entries(list)[0][1];
        // console.log("copyData in Rare", copyData);
        const updatedList =
          Object.entries(list)[0][1]?.fetchDetails?.length > 0 &&
          Object.entries(list)[0][1]?.fetchDetails.filter(
            (nftDetail) => nftDetail.category == "rare"
          );
        // console.log("copyData in Rare", updatedList);
        setShowingList([{ ...copyData, fetchDetails: updatedList }]);
      }
    }
    if (activeLine == "Legendary") {
      if (
        Object.entries(list)?.length > 0 &&
        Object.entries(list)[0]?.length > 0 &&
        Object.entries(list)[0]?.[1]
      ) {
        const copyData = Object.entries(list)[0][1];
        // console.log("copyData in Legendary", copyData);
        const updatedList =
          Object.entries(list)[0][1]?.fetchDetails?.length > 0 &&
          Object.entries(list)[0][1]?.fetchDetails.filter(
            (nftDetail) => nftDetail.category == "legendary"
          );
        // console.log("copyData in Legendary", updatedList);
        setShowingList([{ ...copyData, fetchDetails: updatedList }]);
      }
    }
  }, [activeLine]);

  const checkIsUSDT = (address) => {
    if (address === "0xc2132D05D31c914a87C6611C10748AEb04B58e8F") {
      return true;
    } else {
      return false;
    }
  };

  const convertedPrice = (currency, price) => {
    return checkIsUSDT(currency)
      ? Number(price) / 1000000
      : Number(price) / 1000000000000000000;
  };

  const getTradeCurrency = (id) => {
    let answer = "";

    if (id === "0xc2132D05D31c914a87C6611C10748AEb04B58e8F") {
      answer = "USDT";
    }
    if (id === "0xca082498a1dE55c5d13C5AF2B10CA5e1957349E6") {
      answer = "MLD";
    }
    if (id === "0x0000000000000000000000000000000000001010") {
      answer = "MATIC";
    }

    return answer;
  };

  // console.log("selectfilter", activeLine);
  const getComponent = () => {
    if (isLoadingNFTs) {
      return (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularLoader></CircularLoader>
          </div>
        </>
      );
    } else if (shootdata === null || shootdata === undefined) {
      return <NftNameText></NftNameText>;
    } else if (shootdata.length == 0) {
      return (
        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop:"50px"
        }}>
          <ContentText>No NFTs found</ContentText>
        </div>
      );
    }
     else if (shootdata.length > 0) {
      return (
        <>
          {" "}
          <NftGridContainer>
            {shootdata?.map((item, index) => {
              return (
                <>
                  <NftGridWrapper
                  // onClick={() => {
                  //   if (nftList?.listingStage === 1) {
                  //     navigation(
                  //       `/specificnft/${value.contract.toLowerCase()}/${value.i}`
                  //     );
                  //   } else {
                  //     navigation(
                  //       `/nftdetails/${value.contract.toLowerCase()}/${value.i}`
                  //     );
                  //   }
                  // }}
                  >
                    <NftNewArivalWrapper>
                      <NftCategory
                        common={item?.category === "common"}
                        uncommon={item?.category === "uncommon"}
                      >
                        {item?.category=="uncommon"?"rare":item?.category}
                      </NftCategory>
                      <NftNewArival
                        onClick={() => {
                          if (item?.isFixed === true) {
                            navigation(
                              `/nftdetails/${id}/${parseInt(item?.tokenId)}`
                            );
                          } else {
                            navigation(
                              `/specificnft/${id}/${parseInt(item?.tokenId)}`
                            );
                          }
                        }}
                        // src={value?.fetchDetails?.length > 0 && value?.fetchDetails[index].image ? value.fetchDetails[index].image : Nftcategories1st}
                        src={`${environmentVariables?.cdnUrl}${item?.skinId}.png`}
                      />
                    </NftNewArivalWrapper>
                    <NftNameWrapper>
                      <NftNameText>
                        {item.name}
                      </NftNameText>
                      <NftCountText>
                        {`${item?.count} Left`}
                      </NftCountText>
                    </NftNameWrapper>
                    <PriceButtonContainer>
                      <PriceWrapper>
                        <PriceText Heading>Price: </PriceText>
                        <PriceText PriceTextValue>
                          {item?.price || 0} {item?.currency=="MLD"||item?.currency=="LORD"?"$":""}{item?.currency}
                        </PriceText>
                      </PriceWrapper>
                      <PriceWrapper
                        hashValue
                        onClick={() => {
                          if (item?.isFixed === true) {
                            navigation(
                              `/nftdetails/${id}/${parseInt(item?.tokenId)}`
                            );
                          } else {
                            navigation(
                              `/specificnft/${id}/${parseInt(item?.tokenId)}`
                            );
                          }
                        }}
                      >
                        <Button>
                          {" "}
                          {item?.isFixed === true ? "Place a Bid" : "Buy Now"}
                        </Button>
                      </PriceWrapper>
                    </PriceButtonContainer>
                  </NftGridWrapper>
                  {/* <>{getComponent()}</> */}
                </>
              );
            })}
          </NftGridContainer>
          <Stack
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "50px",
            }}
            spacing={2}
          >
            {/* <Typography style={{ margin: "10px 0 0 0" }}>Page: {page}</Typography> */}
            <Pagination
              shape="rounded"
              color="primary"
              count={totalPages}
              page={page}
              onChange={handleChange}
              sx={{ button: { color: "#ffffff" } }}
            />
          </Stack>
        </>
      );
    }
  };
  return (
    <Root>
      {isLoading && <Loading />}
      <Container>
        <NavSectionWrapper>
          <FilterContainer>
            <SubCatMobile>
              <ImageWrapper>
                <Image onClick={()=>{setShowSubCatFilter(!showSubCatFilter);setShowMobileFilter(false)}} src={filtericon} />
              </ImageWrapper>
            </SubCatMobile>
            <SearchWrapper>
            <SearchIcon src={searchicon}/>
            <SearchInput value={searchKey} onChange={(e)=>setSearchKey(e.target.value)} type="text" placeholder="Search here" />
          </SearchWrapper>
          <FilterWrapper>
            <CategoriesFilter
              selectFilter={selectFilter}
              setSelectFilter={setSelectFilter}
              showMobileFilter={showMobileFilter}
              setShowMobileFilter={setShowMobileFilter}
              setShowSubCatFilter={setShowSubCatFilter}
            />
          </FilterWrapper>
          </FilterContainer>
          <NavSection>
            <Link
              selected={activeLine === "all"||activeLine==null}
              onClick={() => setActiveLine(null)}
            >
              <H1 selected={activeLine === "all"||activeLine==null}>All </H1>
            </Link>

            <Link
              selected={activeLine === "common"}
              onClick={() => setActiveLine("common")}
            >
              <H1 selected={activeLine === "common"}>Common </H1>
            </Link>

            <Link
              selected={activeLine === "uncommon"}
              onClick={() => setActiveLine("uncommon")}
            >
              <H1 selected={activeLine === "uncommon"}>Rare </H1>
            </Link>
            {/* <Link
              selected={activeLine === "rare"}
              onClick={() => setActiveLine("rare")}
            >
              <H1 selected={activeLine === "rare"}>Rare </H1>
            </Link>
            <Link
              selected={activeLine === "legendary"}
              onClick={() => setActiveLine("legendary")}
            >
              <H1 selected={activeLine === "legendary"}>Legendary </H1>
            </Link> */}
          </NavSection>
          
        </NavSectionWrapper>
          {showSubCatFilter && (
                    <DropDownSection style={{top:"126px",left:"20px"}}>
                      <ListWrapper style={{ flexDirection: "column", alignItems: "flex-start" }}>
                        <List style={selectedSubCat=="all"||selectedSubCat==null?{color:"#25a8c5"}:{}} onClick={() => { setSelectedSubCat(null);setShowSubCatFilter(false)}}>All</List>
                        {subCategoriesData&&Array.isArray(subCategoriesData)&&subCategoriesData.length>0&&
                          subCategoriesData.map(val=><List style={selectedSubCat==val?{color:"#25a8c5"}:{}} onClick={() => { setSelectedSubCat(val);setShowSubCatFilter(false)}} >{val}</List>)
                        }
                      </ListWrapper>
                    </DropDownSection>
                  )}
        <NavSectionWrapper>
           <SubCatSection>
            <NavSection style={{marginTop:"0px"}}>
            <Link
              selected={selectedSubCat === "all"||selectedSubCat==null}
              onClick={() => setSelectedSubCat(null)}
            >
              <H2 selected={selectedSubCat === "all"||selectedSubCat==null}>All </H2>
            </Link>
            {
              subCategoriesData&&Array.isArray(subCategoriesData)&&subCategoriesData.length>0&&<>
              {
                subCategoriesData.map(val=> <Link
              selected={selectedSubCat === val }
              onClick={() => setSelectedSubCat(val)}
            >
              <H2 selected={selectedSubCat === val}>{val} </H2>
            </Link>)
              }
              </>
            }

            {/* <Link
              selected={activeLine === "common"}
              onClick={() => setActiveLine("common")}
            >
              <H2 selected={activeLine === "common"}>Male </H2>
            </Link>

            <Link
              selected={activeLine === "uncommon"}
              onClick={() => setActiveLine("uncommon")}
            >
              <H2 selected={activeLine === "uncommon"}>Female </H2>
            </Link> */}
           
          </NavSection>
           </SubCatSection>
          
        </NavSectionWrapper>
        <>{getComponent()}</>
      </Container>
      
    </Root>
  );
};

export default NftCategorisTabs;
